import { combineReducers, Middleware, ReducersMapObject, Store } from "redux";
import { createStore, IModule } from "redux-dynamic-modules";
import thunk from "redux-thunk";
import { presetsEntityReducer, currentPresetReducer, PresetsState } from "~/Redux/preset";
// eslint-disable-next-line @logicsoftware/ep-custom/no-cross-feature-imports
import { predictionFailed } from "../AIForecast/middleware/predictionFailed";
// eslint-disable-next-line @logicsoftware/ep-custom/no-cross-feature-imports
import { imageAnnotationsReducer } from "../messageBoard/imageAnnotations/reducers";
// eslint-disable-next-line @logicsoftware/ep-custom/no-cross-feature-imports
import { AnnotationsPartialState } from "../messageBoard/imageAnnotations/reducers/dtos";
import { getAccountSettingsModule } from "../Redux/AccountSettings";
import { AccountSettingsState } from "../Redux/AccountSettings/reducers/accountSettings";
import { customizationReducer, CustomizationsState } from "../Redux/Customization";
import { apiMiddleware } from "../Redux/Middleware/apiMiddleware";
import { getSagaExtension } from "../Redux/Sagas/getSagaExtension";
import { userFriendlyDialogReducer, UserFriendlyDialogState } from "../Redux/UserFriendlyDialog/reducers";
import { commonEntitiesReducers } from "./reducers/entities";

export type CommonState = AnnotationsPartialState &
    PresetsState &
    CustomizationsState &
    AccountSettingsState & {
        errorDialog?: UserFriendlyDialogState;
    };

type CommonStoreParams = {
    entityReducers?: ReducersMapObject;
    initialState?: any;
    module?: IModule<any>[];
    middlewares?: Middleware[];
};

export const createCommonStore = (params: CommonStoreParams = {}): Store<CommonState> => {
    if (window.store) {
        return window.store;
    }

    const { entityReducers = {}, initialState = {}, module = [], middlewares = [] } = params;

    return (window.store = createStore(
        {
            initialState,
            extensions: [
                {
                    middleware: [...middlewares, predictionFailed, thunk, apiMiddleware],
                },
                getSagaExtension({}),
            ],
        },
        getAppModule(entityReducers),
        getAccountSettingsModule(),
        ...module
    ));
};

const getAppModule = (entityReducers: ReducersMapObject): IModule<CommonState> => ({
    id: "app",
    reducerMap: {
        imageAnnotations: imageAnnotationsReducer(),
        entities: combineReducers({
            ...presetsEntityReducer,
            ...commonEntitiesReducers,
            ...entityReducers,
        }),
        preset: currentPresetReducer,
        customization: customizationReducer,
        errorDialog: userFriendlyDialogReducer,
    },
});
